export default "__VITE_ASSET__BaiOta4p__"